import { memo } from 'react';

import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import { SvgStringToHtml } from 'src/components/SvgStringToHtml';
import { type GenerationTool } from 'src/data/generationTool';
import { PROJECT_TYPE, type ProjectType } from 'src/data/project';

import { GENERATION_TOOL_CARD_IMAGE_SIZE, type GenerationToolCardImageSize } from './const';
import { getGenerationToolCardImage } from './utils';

interface GenerationToolCardImageProps {
  className?: string;
  projectType?: ProjectType;
  tool: GenerationTool;
  svgStringImage?: string;
  size?: GenerationToolCardImageSize;
}

export const GenerationToolCardImage = memo(
  ({
    className,
    projectType = PROJECT_TYPE.document,
    tool,
    svgStringImage,
    size = GENERATION_TOOL_CARD_IMAGE_SIZE.large,
  }: GenerationToolCardImageProps) => {
    if (svgStringImage) {
      return (
        <SvgStringToHtml
          className={className}
          svgString={svgStringImage}
        />
      );
    }

    // The card artwork is drawn for a card. In a row it is reduced far enough that nothing in it
    // is legible, so the tool's own icon — which is drawn for that size — takes its place.
    if (size === GENERATION_TOOL_CARD_IMAGE_SIZE.small) {
      return (
        <GenerationToolIcon
          className={className}
          tool={tool}
        />
      );
    }

    const Icon = getGenerationToolCardImage(projectType, tool, { size });
    return <Icon className={className} />;
  }
);
